import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fac45a80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = ["data-heap"]
const _hoisted_3 = {
  class: "location-step",
  name: "location"
}
const _hoisted_4 = {
  class: "location-step",
  name: "workplace"
}
const _hoisted_5 = {
  "data-testid": "ls-input-workplace",
  class: "location-step-input"
}
const _hoisted_6 = { class: "step-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_location = _resolveComponent("input-location")!
  const _component_joy_selectable_item = _resolveComponent("joy-selectable-item")!
  const _component_joy_selectable_item_group = _resolveComponent("joy-selectable-item-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.title')), 1),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.step1.subtitle')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        "data-heap": _ctx.dataHeapTooltipID,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBottomSheet && _ctx.openBottomSheet(...args)))
      }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.help')), 9, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_input_location, {
        ref: "inputLocation",
        "default-address": _ctx.defaultLocation,
        class: "location-step-input",
        "data-testid": "ls-input-location",
        "blocked-countries-list": _ctx.blockedCountriesList,
        onFocus: _ctx.emitFocus,
        "onInputLocation:validated": _ctx.updateAddress,
        onInput: _ctx.validateAddress
      }, null, 8, ["default-address", "blocked-countries-list", "onFocus", "onInputLocation:validated", "onInput"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.location.step2.subtitle')) + " ", 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_joy_selectable_item_group, {
          value: _ctx.workPlacePreference,
          name: "workplaceList",
          "full-width": "",
          onJoySelectableItemGroupChange: _ctx.updateWorkplace
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workplaces, (workplace) => {
              return (_openBlock(), _createBlock(_component_joy_selectable_item, {
                key: workplace.value,
                value: workplace.value,
                checked: _ctx.isWorkplaceSelected(workplace.value),
                type: "outline"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(workplace.label), 1)
                ]),
                _: 2
              }, 1032, ["value", "checked"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value", "onJoySelectableItemGroupChange"])
      ])
    ])
  ]))
}